import { useCallback, useMemo } from "react";
import { useEventExactness } from "./exactness/useEventExactness";
import { useFamilyExactness } from "./exactness/useFamilyExactness";
import { useNameExactness } from "./exactness/useNameExactness";
import { useOtherFieldsAreExact } from "./exactness/useOtherFieldsExactness";
import { useToggleEventExactness } from "./toggle/useToggleEventExactness";
import { useToggleFamilyExactness } from "./toggle/useToggleFamilyExactness";
import { useToggleNameExactness } from "./toggle/useToggleNameExactness";
import { useToggleOtherFieldExactness } from "./toggle/useToggleOtherFieldExactness";

export const useMatchAllTerms = () => {
    const namesAreExact = useNameExactness();
    const eventsAreExact = useEventExactness();
    const familyRelationsAreExact = useFamilyExactness();
    const otherFieldsAreExact = useOtherFieldsAreExact();
    const toggleNameExactness = useToggleNameExactness();
    const toggleEventExactness = useToggleEventExactness();
    const toggleFamilyExactness = useToggleFamilyExactness();
    const toggleOtherFieldsExactness = useToggleOtherFieldExactness();

    const matchAllTermsExactly = namesAreExact && eventsAreExact && familyRelationsAreExact && otherFieldsAreExact;

    const setMatchAllTermsExactly = useCallback(
        (newValue: boolean) => {
            toggleNameExactness(newValue);
            toggleEventExactness(newValue);
            toggleFamilyExactness(newValue);
            toggleOtherFieldsExactness(newValue);
        },
        [toggleNameExactness, toggleEventExactness, toggleFamilyExactness, toggleOtherFieldsExactness],
    );

    return useMemo(
        () => ({
            matchAllTermsExactly,
            setMatchAllTermsExactly,
        }),
        [matchAllTermsExactly, setMatchAllTermsExactly],
    );
};
